export default __webpack_public_path__ + "static/media/connection-settings.f0340652.svg";